































































































import {Component} from 'vue-property-decorator';
import {Getter, Action} from "vuex-class";
import ReportsFilter from "@/components/Reports/ReportsFilter.vue";
import {DistributionItem} from "@/store/templates/types";
import {ScrollButton, LongTextWings} from 'wings-ui-components';
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {dateFilter} from "@/utils/date-util";
import {notifyError} from "@/utils/notify-helper";
import { ActionLog } from '@/store/auth/types';
import ReportInfoDialog from '@/components/Reports/ReportInfoDialog.vue';

@Component({components: {ReportsFilter,LongTextWings,ScrollButton,ReportInfoDialog}, filters: {dateFilter}})
export default class Reports extends BaseItemsPage<DistributionItem> {
  @Getter("reports") reports: any;

  @Action("downloadReport") actionDownloadReport: any;
  @Action("removeReport") actionRemoveReport: any;
  @Action("actionLog") actionLog: any;
  @Action("getReportAdditionalInfo") actionGetReportAdditionalInfo: any;

  is_show_filter = true;
  currentSort = "create_date";
  currentSortOrder = "desc";

  showInfo = false;
  messageContent = null;

  logObject: ActionLog = {}

  // "id": 1,
  // "status": "FINISHED",
  // "create_date": "2022-05-26T16:16:42",
  // "finish_date": "2022-05-26T16:16:44",
  // "name": "DetailStatisticsSms_2022-05-26-16-16-42.zip"

  tableFields = [
    'id',
    'create_date',
    'finish_date',
    'name',
    'type',
    'status',
  ];

  getData(): any {
    return this.reports;
  }

  async downloadReport(item: any) {
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Report downloading",
        actionStatus: 'success',
        objectType: "Report",
        objectName: item.name,
      }
      await this.actionDownloadReport(item.id)
      await this.actionLog(this.logObject)
    } catch(error) {
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
      notifyError(error);
    }
  }

  async removeReport(item: any) {
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Report deleting",
        actionStatus: 'success',
        objectType: "Report",
        objectName: item.name,
      }
      await this.actionRemoveReport(item.id)
      await this.actionLog(this.logObject)
      this.runFilter = true;
    } catch(error) {
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
      notifyError(error);
    }
  }

  async showInfoDialog(id: number) {
    try {
      this.messageContent = await this.actionGetReportAdditionalInfo(id);
      this.showInfo = true
    } catch(error) {
      notifyError(error);
    }
  }

  statusItemColor(status:string){
    switch (status.toLowerCase()) {
      case 'finished':
        return 'background-chip-success'
      case 'failed':
        return 'background-chip-danger'
      default:
        return 'background-chip-warning'
    }
  }

}
